/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  SpeechToTextHistoryObject,
  SpeechToTextHistoryObject$inboundSchema,
  SpeechToTextHistoryObject$Outbound,
  SpeechToTextHistoryObject$outboundSchema,
} from "./speechtotexthistoryobject.js";

/**
 * A paginated list of speech-to-text history items.
 */
export type SpeechToTextHistoryList = {
  object: "list";
  data: Array<SpeechToTextHistoryObject>;
  firstId?: string | undefined;
  lastId?: string | undefined;
  hasMore: boolean;
};

/** @internal */
export const SpeechToTextHistoryList$inboundSchema: z.ZodType<
  SpeechToTextHistoryList,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("list"),
  data: z.array(SpeechToTextHistoryObject$inboundSchema),
  first_id: z.string().optional(),
  last_id: z.string().optional(),
  has_more: z.boolean(),
}).transform((v) => {
  return remap$(v, {
    "first_id": "firstId",
    "last_id": "lastId",
    "has_more": "hasMore",
  });
});
/** @internal */
export type SpeechToTextHistoryList$Outbound = {
  object: "list";
  data: Array<SpeechToTextHistoryObject$Outbound>;
  first_id?: string | undefined;
  last_id?: string | undefined;
  has_more: boolean;
};

/** @internal */
export const SpeechToTextHistoryList$outboundSchema: z.ZodType<
  SpeechToTextHistoryList$Outbound,
  z.ZodTypeDef,
  SpeechToTextHistoryList
> = z.object({
  object: z.literal("list"),
  data: z.array(SpeechToTextHistoryObject$outboundSchema),
  firstId: z.string().optional(),
  lastId: z.string().optional(),
  hasMore: z.boolean(),
}).transform((v) => {
  return remap$(v, {
    firstId: "first_id",
    lastId: "last_id",
    hasMore: "has_more",
  });
});

export function speechToTextHistoryListToJSON(
  speechToTextHistoryList: SpeechToTextHistoryList,
): string {
  return JSON.stringify(
    SpeechToTextHistoryList$outboundSchema.parse(speechToTextHistoryList),
  );
}
export function speechToTextHistoryListFromJSON(
  jsonString: string,
): SafeParseResult<SpeechToTextHistoryList, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SpeechToTextHistoryList$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SpeechToTextHistoryList' from JSON`,
  );
}
